import React, { useEffect } from 'react'
import {
  Button,
  Spinner,
  Row,
  Col,
  Table,
  Label
} from 'reactstrap';
import { FaRegEye, FaArrowLeft, FaLongArrowAltRight } from 'react-icons/fa'
import { MdDelete } from 'react-icons/md'
import { useHistory, useParams } from 'react-router-dom';


// @components
import TarjetaContenido from 'components/TarjetaContenido/TarjetaContenido';
import PaginaPorDefecto from './Default';

// @hooks
import { useEncuesta } from 'hooks/useEncuesta'
import { useEncuestaPregunta } from 'hooks/useEncuestaPregunta'
import { usePreguntaGrupoInteres } from 'hooks/usePreguntaGrupoInteres'

// @constants
import { RUTAS } from 'constants/constants';

export default function DetalleEncuesta () {
  /**
   * Hooks
   */
  const { push } = useHistory();
  const { id } = useParams();

  /**
   * Consultas
   */
  const {
    handleBuscarEncuestaPorId,
  } = useEncuesta()

  const { 
    useObtenerEncuestaPreguntaPorField,
    handleCrearEncuestaPregunta,
    handleEliminarEncuestaPregunta,
  } = useEncuestaPregunta()

  const { obtenerPreguntaGrupoInteresByfield } = usePreguntaGrupoInteres()
  
  const { data: encuesta } = handleBuscarEncuestaPorId(id);
  const { data: preguntasEncuesta }
    = useObtenerEncuestaPreguntaPorField('encuesta__id', id);
  
  const { data: preguntasGrupoInteres, refetch: refetchPosiblesPreguntas }
    = obtenerPreguntaGrupoInteresByfield(
      'grupo_interes__id', encuesta?.grupo_interes?.id
    );
  const posiblesPreguntas = preguntasGrupoInteres?.results?.filter((pregunta) => {
    return !preguntasEncuesta?.results?.find((preguntaEncuesta) => {
      return +preguntaEncuesta.preguntas__id === pregunta.preguntas;
    });
  });
  
  /**
   * Efectos
   */
  useEffect(() => {
    refetchPosiblesPreguntas()
  }, [
    encuesta,
    refetchPosiblesPreguntas,
  ])
  

  /**
   * Manjeadores
   */
  const manejadorVistaPrevia = () => {
    push(RUTAS.VISTA_PREVIA_ENCUESTA.replace(':id', id))
  }

  const manejadorRegresar = () => {
    push(RUTAS.ENCUESTAS);
  }

  return (
    <PaginaPorDefecto 
      titulo={
        <span>
          <span title="Regresar" >
            <Button className="mr-3" color="link" onClick={manejadorRegresar}>
              <FaArrowLeft />
            </Button>
          </span>
          Detalles de encuesta {
          !encuesta && <Spinner color='primary' className="ml-3" />
        }</span>
      }
    >
      <TarjetaContenido
        titulo="Detalles"
        component={
          <span title="Vista previa">
            <Button outline color='primary' onClick={manejadorVistaPrevia}>
              <FaRegEye />
            </Button>
          </span>
        }
      >
        {encuesta && (
          <>
            <Row>
              <Col>
                <h1>{encuesta.titulo}</h1>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col>
                <h3>Orientada a: {encuesta.grupo_interes?.nombre}</h3>
              </Col>
            </Row>
            <Row>
              <Col>
                <p style={{ textAlign: 'justify' }}>{
                    encuesta.descripcion?.split('\n')?.map((parrafo, index) => (
                      <span key={index}>{parrafo}<br /></span>
                    ))
                  }</p>
              </Col>
            </Row>
          </>
          )
        }
        <Row className="mt-3">
          <Col md={6}>
            <Label><strong>Posibles preguntas</strong></Label>
          </Col>
          <Col md={6}>
            <Label><strong>Preguntas añadidas</strong></Label>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Table responsive>
              <thead>
                <tr>
                  <th>Identificador</th>
                  <th>Enunciado</th>
                  <th>Actiones</th>
                </tr>
              </thead>
              <tbody>
                {posiblesPreguntas?.length === 0 && (
                  <tr>
                    <td
                      colSpan={3}
                      style={{ display: 'flex', justifyContent: 'center' }}
                    >
                      No hay preguntas
                    </td>
                  </tr>
                )}
                {posiblesPreguntas?.map((pregunta, index) => {
                  const manejadorAñadirPregunta = () => {
                    handleCrearEncuestaPregunta({
                      encuesta: id,
                      preguntas_grupo_interes: pregunta.id
                    })
                  }
                  return (
                  <tr key={index}>
                    <td><strong>{pregunta.preguntas__identificador}</strong></td>
                    <td>
                      {pregunta.preguntas__enunciado}
                    </td>
                    <td>
                      <span title="Añadir a encuesta">
                        <Button outline
                          color='primary'
                          size='sm'
                          onClick={manejadorAñadirPregunta}
                        >
                          <FaLongArrowAltRight />
                        </Button>
                      </span>
                    </td>
                  </tr>
                )})}
              </tbody>
            </Table>
          </Col>
          <Col md={6}>
            <Table responsive>
              <thead>
                <tr>
                  <th>Identificador</th>
                  <th>Enunciado</th>
                  <th>Actiones</th>
                </tr>
              </thead>
              <tbody>
                {preguntasEncuesta?.results?.length === 0 && (
                  <tr>
                    <td
                      colSpan={3}
                      style={{ display: 'flex', justifyContent: 'center' }}
                    >
                      No hay preguntas
                    </td>
                  </tr>
                )}
                {preguntasEncuesta?.results?.map((pregunta, index) => {
                  const manejadorEliminarPregunta = () => {
                    handleEliminarEncuestaPregunta({id: pregunta.id, nombre: pregunta.identificador})
                  }

                  return (
                  <tr key={index}>
                    <td><strong>{pregunta.preguntas__identificador}</strong></td>
                    <td>{pregunta.preguntas__enunciado}</td>
                    <td>
                      <span title="Remover de encuesta">
                        <Button outline
                          color='primary'
                            size='sm'
                            onClick={manejadorEliminarPregunta}
                        >
                          <MdDelete />
                        </Button>
                      </span>
                      
                    </td>
                  </tr>
                )})}
              </tbody>
            </Table>
          </Col>
        </Row>
      </TarjetaContenido>
    </PaginaPorDefecto>
  )
}
